import { ForgeCandidateDesign } from '../types';

const MIN_SIMILARITY = 0.75;
const MIN_CANDIDATES = 3;

/** Max number of candidates selectable via number keys. */
export const MAX_NUMBER_KEYS = 7;

/**
 * Filter candidate designs: same-UPC first, then other-UPC.
 * Returns all above 75% similarity (min 3), or top 3 if fewer qualify.
 */
export function filterCandidates(
  candidates: ForgeCandidateDesign[],
  currentUpc: string | undefined
): ForgeCandidateDesign[] {
  if (!currentUpc) return candidates;
  const sameUpc = candidates.filter((v) => v.upc === currentUpc);
  const otherUpc = candidates.filter((v) => v.upc !== currentUpc);
  const all = [...sameUpc, ...otherUpc];
  const aboveThreshold = all.filter((v) => v.similarity >= MIN_SIMILARITY);
  if (aboveThreshold.length >= MIN_CANDIDATES) return aboveThreshold;
  return all.slice(0, Math.max(MIN_CANDIDATES, aboveThreshold.length));
}
